const stripTrailingSlash = (value = "") => value.replace(/\/+$/, "");

const logMissingBase = (label) => {
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      `[apiBase] Missing ${label}. Please define it in your .env file to avoid empty requests.`
    );
  }
};

export const getNodeApiBase = () => {
  const fallback = process.env.NODE_ENV === "development" ? "http://localhost:3001" : "";
  const base =
    process.env.REACT_APP_NODE_API_BASE ||
    process.env.REACT_APP_API_BASE ||
    process.env.REACT_APP_BACKEND_URL ||
    fallback;

  if (!base) {
    logMissingBase("REACT_APP_NODE_API_BASE (or fallback)");
  }

  return stripTrailingSlash(base);
};

export const getPhpBaseUrl = () => {
  const base = process.env.REACT_APP_BASE_URL || "";

  if (!base) {
    logMissingBase("REACT_APP_BASE_URL");
  }

  return stripTrailingSlash(base);
};
